// extracted by mini-css-extract-plugin
export default {"Overlay":"ModalNew_Overlay__PjZDJ","Modal":"ModalNew_Modal__2PpjV","ModalContainer":"ModalNew_ModalContainer__uDW1v"};